













































































































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { ArtStudent } from '@/models/enrolls/artStudent'
import BirthYearMonthPicker from '@/components/exam/BirthYearMonthPicker.vue'
import NationalSelect from '@/components/exam/NationalSelect.vue'
import SexSelect from '@/components/exam/SexSelect.vue'
import EnrollTextarea from '@/components/exam/EnrollTextarea.vue'
import { getKey } from '@/utils/key'

@Component({
  components: {
    BirthYearMonthPicker,
    NationalSelect,
    SexSelect,
    EnrollTextarea
  }
})
export default class ArtStudentEnrollForm extends Vue {
  @Prop({ required: true }) value!: ArtStudent
  @Prop({ default: false }) print!: boolean
  @Prop({ default: '' }) title!: string
  getKey = getKey

  get form() {
    return this.value
  }

  set form(value: ArtStudent) {
    this.$emit('update:value', value)
  }

  get birthday() {
    const { birthYear, birthMonth } = this.form
    if (birthYear !== '' && birthMonth !== '') {
      return `${birthYear}-${birthMonth}`
    } else {
      return null
    }
  }

  set birthday(date) {
    if (date) {
      const [year, month] = date.split('-')
      this.form.birthYear = year
      this.form.birthMonth = month
    } else {
      this.form.birthYear = ''
      this.form.birthMonth = ''
    }
  }
}
